import { getAccessToken } from './auth0-client';
import { isLocalhost } from './client';

/** Flag key to value. A flag that is not in the map is off. */
export type FeatureFlags = Record<string, boolean>;

interface FeatureFlagsResponse {
  flags: FeatureFlags;
}

/** subscription-manager ran on localhost has no managed identity
 * so the hub refuses the request. */
export const LOCAL_FEATURE_FLAGS: FeatureFlags = { FF_LOCAL_DUMMY: true };

/**
 * Fetches the flag values for the workspace in the caller's token (CLOUD-932).
 * The apps cannot reach the internal hub, so subscription-manager reads it for them.
 */
export async function fetchFeatureFlags(baseUrl: string): Promise<FeatureFlags> {
  if (isLocalhost(new URL(baseUrl).hostname)) return LOCAL_FEATURE_FLAGS;

  const token = await getAccessToken();
  if (!token) throw new Error('No authenticated session');
  const response = await fetch(`${baseUrl}/v1/feature-flags`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`Feature flags request failed with status ${response.status}`);
  const body = (await response.json()) as FeatureFlagsResponse;
  return body.flags;
}
